// src/pages/admin/SectionForm.js completo e corrigido
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';

// IMPORTAÇÕES COM OS NOVOS NOMES ESTRUTURAIS
import HorizontalTimelineManager from './HorizontalTimelineManager';
import InstitutionalLogosManager from './InstitutionalLogosManager';
import FeaturesListManager from './FeaturesListManager';
import ProductShowcaseManager from './ProductShowcaseManager';

const SectionForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  // Constante com a nova URL base do painel visual
  const CMS_BASE_URL = '/jb-acesso-master-control-cms';

  const [formData, setFormData] = useState({
    title: '',
    navbar_title: '', 
    subtitle: '',
    subtitle_2: '',
    subtitle_3: '',
    content_2: '',
    content: '',
    slug: '',
    section_order: 0,
    is_active: true,
    background_type: 'none',
    background_color: '#f8f9fa',
    background_opacity: 100,
    transition_image_url: '',
    component_type: 'info_block',
    remove_transition: false 
  });
  
  const [imageFile, setImageFile] = useState(null);
  const [transitionFile, setTransitionFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showItemManagerModal, setShowItemManagerModal] = useState(false);

  useEffect(() => {
    if (isEdit) {
      api.get(`/admin/sections/${id}`) 
        .then(res => {
          const data = res.data.data || res.data;
          
          // Correção: Se for mapa, não deixa o background_type travar em 'image'
          let bgType = data.background_type || 'none';
          if (data.component_type === 'map_location_block' && bgType === 'image') {
            bgType = 'none';
          }

          setFormData({
            title: data.title || '',
            navbar_title: data.navbar_title || '',
            subtitle: data.subtitle || '',
            subtitle_2: data.subtitle_2 || '',
            subtitle_3: data.subtitle_3 || '',
            content_2: data.content_2 || '',
            content: data.content || '',
            slug: data.slug || '',
            section_order: data.section_order || 0,
            is_active: data.is_active !== undefined ? data.is_active : true,
            background_type: bgType, // Usa a variável corrigida aqui
            background_color: data.background_color || '#f8f9fa',
            background_opacity: data.background_opacity || 100,
            transition_image_url: data.transition_image_url || '',
            component_type: data.component_type || 'info_block',
            remove_transition: false
          });
        })
        .catch(err => console.error("Erro ao carregar seção", err));
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    Object.keys(formData).forEach(key => data.append(key, formData[key]));
    
    // CORREÇÃO: Permite enviar a imagem tanto se for Fundo de Imagem, QUANTO se for Mapa.
    if ((formData.background_type === 'image' || formData.component_type === 'map_location_block') && imageFile) {
      data.append('image', imageFile);
    }

    if (transitionFile) {
      data.append('transition_image', transitionFile);
    }

    try {
      if (isEdit) {
        await api.put(`/admin/sections/${id}`, data);
      } else {
        await api.post('/admin/sections', data);
      }
      navigate(`${CMS_BASE_URL}/sections`);
    } catch (err) {
      alert('Erro ao salvar seção. Verifique os campos.');
    } finally {
      setLoading(false);
    }
  };

  const layoutsWithItems = ['horizontal_timeline', 'institutional_with_logos', 'features_list', 'product_showcase', 'dynamic_post_feed'];
  const needsItemManager = layoutsWithItems.includes(formData.component_type);

  const renderItemManager = () => {
    switch (formData.component_type) {
      case 'product_showcase': return <ProductShowcaseManager sectionId={id} />;
      case 'horizontal_timeline': return <HorizontalTimelineManager sectionId={id} />;
      case 'features_list': return <FeaturesListManager sectionId={id} />;
      case 'institutional_with_logos': return <InstitutionalLogosManager sectionId={id} />;
      case 'dynamic_post_feed': 
         return <div className="alert alert-info">Este feed é automático. Configure a URL no menu de Configurações Globais.</div>;
      default: return null;
    }
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
        <h5 className="mb-0 fw-bold">{isEdit ? 'Editar Seção' : 'Nova Seção'}</h5>
        {isEdit && <span className="badge bg-light text-dark border">ID: {id}</span>}
      </div>
      
      <div className="card-body p-4">
        <form onSubmit={handleSubmit}>

          <div className="mb-4 p-3 border border-primary rounded bg-light">            
            <label className="form-label fw-bold text-primary small">
              <i className="bi bi-layout-text-window-reverse me-2"></i>
              MOLDE VISUAL DA SEÇÃO (Layout)
            </label>
            <select 
              name="component_type" 
              className="form-select form-select-lg fw-bold mb-2" 
              value={formData.component_type} 
              onChange={handleChange}
            >
              <option value="info_block">Bloco de Informação Genérico (Ex: Modelo de Negócio)</option>
              <option value="features_list">Lista de Destaques (Ex: O Destino)</option>
              <option value="product_showcase">Vitrine de Produto (Ex: Plantas e Benefícios)</option>
              <option value="map_location_block">Bloco de Localização (Mapa)</option>
              <option value="institutional_with_logos">Institucional com Logos (Ex: Quem Somos)</option>
              <option value="horizontal_timeline">Linha do Tempo Horizontal (Ex: Acompanhamento de Obra)</option>
              <option value="dynamic_post_feed">Feed Dinâmico (Ex: Blog)</option>
              <option value="lead_capture_form">Formulário de Captura (Ex: Fale Conosco)</option>
            </select>
            <small className="text-muted d-block mt-1">
              Isto define a estrutura visual do código no site. O nome (título) da seção pode ser alterado livremente abaixo.
            </small>

            {isEdit && needsItemManager && (
              <div className="mt-3 pt-3 border-top d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="fw-bold mb-0 text-dark">Conteúdo Dinâmico deste Layout</h6>
                  <p className="small text-muted mb-0">Gerencie fotos, cards, parceiros ou abas específicas deste molde.</p>
                </div>
                <button 
                  type="button" 
                  className="btn btn-primary fw-bold px-4"
                  onClick={() => setShowItemManagerModal(true)}
                >
                  <i className="bi bi-grid-fill me-2"></i>
                  CONFIGURAR ITENS DO LAYOUT
                </button>
              </div>
            )}
          </div>

          {formData.component_type === 'product_showcase' && (
            <div className="alert alert-warning mb-4 small d-flex align-items-center border-0 shadow-sm" style={{ backgroundColor: '#fff3cd', color: '#856404' }}>
              <div className="fs-5 me-2">💡</div>
              <div>
                <strong>Aviso de UX:</strong> Neste molde visual, o Título, Subtítulo e Descrição são controlados de forma individual por cada banner interno para evitar quebras de layout. Para alterá-los, utilize o botão laranja <strong>"CONFIGURAR ITENS DO LAYOUT"</strong> logo acima.
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-md-8 mb-3">
              <label className="form-label fw-bold small">TÍTULO PRINCIPAL</label>
              <input type="text" name="title" className="form-control" style={formData.component_type === 'product_showcase' ? { backgroundColor: '#d6d6d6', color: '#495057' } : {}} value={formData.title} onChange={handleChange} required disabled={formData.component_type === 'product_showcase'}/>
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label fw-bold small">ORDEM</label>
              <input type="number" name="section_order" className="form-control" value={formData.section_order} onChange={handleChange} />
            </div>
          </div>

          <div className="mb-3 p-3 bg-light border rounded">
            <label className="form-label fw-bold text-primary small">TÍTULO NO MENU (Navbar)</label>
            <input 
              type="text" 
              name="navbar_title" 
              className="form-control" 
              style={formData.component_type === 'product_showcase' ? { backgroundColor: '#d6d6d6', color: '#495057' } : {}}
              value={formData.navbar_title} 
              onChange={handleChange} 
              placeholder="Ex: Home, O Destino, Localização..." 
              disabled={formData.component_type === 'product_showcase'}
            />
            <small className="text-muted d-block mt-1">Nome curto que aparecerá no menu superior do site. Se deixado em branco, o sistema usará o Título Principal acima.</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold small">SUBTÍTULO</label>
            <input type="text" name="subtitle" className="form-control" style={formData.component_type === 'product_showcase' ? { backgroundColor: '#d6d6d6', color: '#495057' } : {}} value={formData.subtitle} onChange={handleChange} disabled={formData.component_type === 'product_showcase'} />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold small">CONTEÚDO / TEXTO Principal</label>
            <textarea name="content" className="form-control" rows="4" style={formData.component_type === 'product_showcase' ? { backgroundColor: '#d6d6d6', color: '#495057' } : {}} value={formData.content} onChange={handleChange} disabled={formData.component_type === 'product_showcase'}></textarea>
          </div>

          {formData.component_type === 'institutional_with_logos' && (
            <div className="mt-4 p-4 border border-info rounded bg-light">
              <h6 className="fw-bold text-info mb-3"><i className="bi bi-diagram-3-fill me-2"></i>Campos Específicos: Quem Somos</h6>
              <div className="mb-3">
                <label className="form-label fw-bold small text-dark">SUBTÍTULO 2 (Acima do carrossel de logos)</label>
                <input type="text" name="subtitle_2" className="form-control" value={formData.subtitle_2} onChange={handleChange} />
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="form-label fw-bold small text-dark">SUBTÍTULO 3 (Título da Parte Legal)</label>
                  <input type="text" name="subtitle_3" className="form-control" value={formData.subtitle_3} onChange={handleChange} placeholder="Ex: Parte Legal" />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="form-label fw-bold small text-dark">CONTEÚDO 2 (Texto da Parte Legal)</label>
                  <textarea name="content_2" className="form-control" rows="3" value={formData.content_2} onChange={handleChange}></textarea>
                </div>
              </div>
            </div>
          )}

          {/* NOVA ÁREA DE FUNDOS DESACOPLADA DO MAPA */}
          <div className="row align-items-end border-top pt-4 mt-2">
            <div className="col-md-4 mb-3">
              <label className="form-label fw-bold small">SLUG (Identificador único)</label>
              <input type="text" name="slug" className="form-control" value={formData.slug} onChange={handleChange} required />
            </div>

            <div className="col-md-8 mb-3">
              <label className="form-label fw-bold small d-block">ESTILO DE FUNDO DA SEÇÃO</label>
              <div className="btn-group w-100" role="group">
                <input type="radio" className="btn-check" name="background_type" id="bg_none" value="none" checked={formData.background_type === 'none'} onChange={handleChange} />
                <label className="btn btn-outline-dark" htmlFor="bg_none">Padrão</label>

                <input type="radio" className="btn-check" name="background_type" id="bg_color" value="color" checked={formData.background_type === 'color'} onChange={handleChange} />
                <label className="btn btn-outline-dark" htmlFor="bg_color">Cor Sólida</label>

                {/* Removemos o botão de imagem se for Mapa, pois o mapa já usa esse campo por trás dos panos */}
                {formData.component_type !== 'product_showcase' && formData.component_type !== 'map_location_block' && (
                  <>
                    <input type="radio" className="btn-check" name="background_type" id="bg_image" value="image" checked={formData.background_type === 'image'} onChange={handleChange} />
                    <label className="btn btn-outline-dark" htmlFor="bg_image">Imagem</label>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row mb-4 p-3 rounded bg-light border">
            {/* RENDERIZAÇÃO 1: COR (Aparece se Cor Sólida estiver marcada) */}
            {formData.background_type === 'color' && (
              <div className="col-md-12 mb-3">
                <label className="form-label fw-bold small">ESCOLHA A COR DE FUNDO</label>
                <div className="d-flex align-items-center gap-3">
                  <input type="color" name="background_color" className="form-control form-control-color" value={formData.background_color} onChange={handleChange} style={{width: '100px'}} />
                  <span className="text-muted small">Clique para abrir a paleta de cores</span>
                </div>
              </div>
            )}

            {/* RENDERIZAÇÃO 2: UPLOAD (Aparece se Fundo de Imagem estiver marcado OU se for bloco de Mapa) */}
            {(formData.background_type === 'image' || formData.component_type === 'map_location_block') && (
              <div className="col-md-12">
                
                {/* Linha divisória suave se a caixa de upload aparecer junto com a paleta de cor */}
                {formData.background_type === 'color' && formData.component_type === 'map_location_block' && (
                   <hr className="text-muted opacity-25" />
                )}

                <div className="row align-items-center">
                  <div className="col-md-8 mb-3 mb-md-0">
                    <label className="form-label fw-bold small text-primary">
                      {formData.component_type === 'map_location_block' ? (
                        <><i className="bi bi-map-fill me-2"></i>IMAGEM DO MAPA LÚDICO (Opcional se já existir)</>
                      ) : (
                        'IMAGEM DE FUNDO (BACKGROUND)'
                      )}
                    </label>
                    <input type="file" className="form-control border-primary" onChange={(e) => setImageFile(e.target.files[0])} />
                    {formData.component_type === 'map_location_block' && (
                      <small className="text-muted d-block mt-1">
                        Esta imagem aparecerá à esquerda do Google Maps na seção de Localização, <strong>independente da cor de fundo escolhida acima.</strong>
                      </small>
                    )}
                  </div>                
                  
                  {/* Opacidade só aparece se NÃO for o bloco de mapa */}
                  {formData.component_type !== 'map_location_block' && (
                    <div className="col-md-4">
                      <label className="form-label fw-bold small d-block mb-2">
                        OPACIDADE ({formData.background_opacity}%)
                      </label>
                      <input type="range" className="form-range" min="1" max="100" step="1" name="background_opacity" value={formData.background_opacity} onChange={handleChange} />
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* RENDERIZAÇÃO 3: PADRÃO */}
            {formData.background_type === 'none' && formData.component_type !== 'map_location_block' && (
              <div className="col-md-12 text-muted small">Fundo padrão do Design System selecionado.</div>
            )}
          </div>
          {/* FIM DA ÁREA DE FUNDOS DESACOPLADA DO MAPA */}

          <div className="border-top pt-4 mt-4">
            <h6 className="fw-bold mb-3 text-primary">FRASES DE TRANSIÇÃO (ONDA PNG)</h6>
            <div className="row p-3 rounded bg-light border">
              <div className="col-md-8">
                <label className="form-label fw-bold small">SUBSTITUIR OU ADICIONAR ONDA</label>
                <input type="file" className="form-control" onChange={(e) => setTransitionFile(e.target.files[0])} />
                <p className="text-muted small mt-2">Dica: Use arquivos .PNG transparentes para as frases.</p>
              </div>
              
              {formData.transition_image_url && (
                <div className="col-md-4 text-center border-start">
                  <label className="form-label fw-bold small d-block">FRASE ATUAL</label>
                  <img src={`${backendUrl}${formData.transition_image_url}`} alt="Preview Onda" className="img-fluid rounded mb-2 border" style={{ maxHeight: '60px' }} />
                  <div className="form-check justify-content-center d-flex gap-2">
                    <input className="form-check-input" type="checkbox" name="remove_transition" id="removeTrans" checked={formData.remove_transition} onChange={handleChange} />
                    <label className="form-check-label text-danger small fw-bold" htmlFor="removeTrans">EXCLUIR ESTA FRASE</label>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="my-4 form-check form-switch">
            <input className="form-check-input" type="checkbox" name="is_active" checked={formData.is_active} onChange={handleChange} id="activeCheck" />
            <label className="form-check-label fw-bold" htmlFor="activeCheck">Seção Ativa (Visível no site)</label>
          </div>

          <div className="d-flex gap-2">
            <button type="submit" className="btn btn-dark px-5 py-2 fw-bold" disabled={loading}>
              {loading ? 'Processando...' : 'SALVAR ALTERAÇÕES'}
            </button>
            <button type="button" className="btn btn-outline-secondary px-4" onClick={() => navigate(`${CMS_BASE_URL}/sections`)}>CANCELAR</button>
          </div>
        </form>
      </div>

      {showItemManagerModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }}>
          <div className="modal-dialog modal-dialog-centered" style={formData.component_type === 'product_showcase' || formData.component_type === 'features_list' ? { maxWidth: '1400px' } : { maxWidth: '800px' }}>
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-dark text-white border-0">
                <h5 className="modal-title fw-bold">Gestão de Itens - {formData.title}</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowItemManagerModal(false)}></button>
              </div>
              <div className="modal-body p-4" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                {renderItemManager()}
              </div>
              <div className="modal-footer bg-light border-0">
                <button type="button" className="btn btn-secondary fw-bold" onClick={() => setShowItemManagerModal(false)}>FECHAR</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionForm;